import { IonContent } from '@ionic/react'
import React, { BaseSyntheticEvent, useEffect } from 'react'
import { IonButton, IonButtons, IonHeader, IonIcon, IonPage, IonToolbar, IonTitle } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getVersion } from '../../../utilities'
import { AuthenticationService } from '../../login/services/authentication.service'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { useSelector } from 'react-redux'
import { getUserSelector } from '../../user/selectors'
import Logger from '../../../services/logger.service'

const HelpGuide = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const currVersion: string = getVersion()
  const user = useSelector(getUserSelector)

  const allowSecureRoutes = AuthenticationService.allowSecureRoutes(user)
  useEffect(() => {
    if (!allowSecureRoutes) {
      Logger.warn('User is not authenticated. Redirecting to index route.')
      history.push(AppRouterConstants.INDEX_ROUTE)
    }
  }, [allowSecureRoutes])

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.back()
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('common.HelpGuide')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className='no-footer-content'>
        <iframe
          src={`https://help.zollonline.com/emscharts-NOW/Content/emsCharts%20NOW/Overview.htm?type=mobile&version=${currVersion}`}
          title='Zoll Online EmsCharts Now'
          height='100%'
          width='100%'></iframe>
      </IonContent>
    </IonPage>
  )
}

export default HelpGuide
